import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import {VENDOR_NAMES} from '@/constants/billingConstants';

const state = {
  filterData: {},
  utilizationList: {
    totalCount: 0,
    list: []
  },
  totalSummary: {
    netSavingsUtil: null,
    usePaymentUtil: null,
    utilization: null,
    totalPayment: null,
    usePayment: null,
    netSavings: null,
    ondemandSpend: null
  },
  transition: [],
  selectedVendor: VENDOR_NAMES.AWS,
  selectedViewByOption: '',
  isFilterLoading: true,
  isTotalSummaryLoading: true,
  isUsageListLoading: true,
  isTransitionLoading: true
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/savings-plans/utilization/index.js